// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1UiMQ","unreadBadge":"styles_unreadBadge__2UcoF","modalContent":"styles_modalContent__gqJtG","modal":"styles_modal__2xZY5"};